export const getHashByIndex = (hash: string, index: number) => {
    if (hash) {
        if (isNaN(index)) return hash;

        var hashArray = hash
            .split('#')
            .filter(function (str) {
                return Boolean(str);
            })
            .map(function (str) {
                return '#' + str;
            });

        return hashArray[index] || null;
    }

    return null;
};
